__turbopack_context__.v({
  "directionsLink": "performanceLabContactLinks-module__a_kc-q__directionsLink",
  "phoneLink": "performanceLabContactLinks-module__a_kc-q__phoneLink",
});
